import { createContext, useContext, useState } from "react";

const InfoProviderContext = createContext();

export const useInfoProvider = () => useContext(InfoProviderContext);

const InfoProvider = ({ children }) => {
  const [info, setInfo] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  return (
    <InfoProviderContext.Provider
      value={{
        info,
        setInfo,
        loading,
        setLoading,
        error,
        setError,
      }}
    >
      {children}
    </InfoProviderContext.Provider>
  );
};

export default InfoProvider;
